export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

export const urlImg = "https://res.cloudinary.com/daprno5qo/image/upload";

export const KEYS = {
  monto: "Ingresa un monto a invertir",
  type: "Selecciona un método de pago",
  card: "Ingresa el número de tu tarjeta",
  exp: "Ingresa la fecha de expiración de tu tarjeta",
  cvv: "Ingresa el código de seguridad de tu tarjeta",
};

export const MODAL_MESSAGES = {
  "SUCCESS_DOC": {
    title: "¡Documento recibido! \nTu inversión está en revisión",
    subtitle: "Hemos recibido tu PDF correctamente. Ahora verificaremos los detalles de tu inversión. Te notificaremos cuando el proceso haya sido completado. \n¡Gracias por confiar en nosotros y ser parte de esta oportunidad!",
    img: "/Successmark.png",
    btnAction: "Siguiente",
  },
  "SUCCESS_INVERSION": {
    title: "¡Éxito! \nTu inversión ha sido recibida",
    subtitle: "Hemos recibido tu pago. Te mantendremos informado sobre el progreso del proyecto. ¡Gracias por confiar en nosotros y ser parte de esta oportunidad!",
    img: "/Successmark.png",
    btnAction: "Siguiente",
  },
  "PENDING_INVERSION": {
    title: "¡Éxito! \nTu inversión ha sido recibida",
    subtitle: "Hemos recibido tu transacción se aprovará entre 24h y 48h. Te mantendremos informado.",
    img: "/Successmark.png",
    btnAction: "Siguiente",
  },
  "ERROR_DOC": {
    title: "¡Ups! Algo salió mal \nHubo un problema al cargar tu archivo PDF",
    subtitle: "Asegúrate de que cumple con los requisitos de formato y tamaño permitidos. Intenta subir el archivo de nuevo o selecciona un PDF diferente.",
    img: "/Errormark.png",
    btnAction: "Intentar de nuevo",
  },
  "ERROR_INVERSION": {
    title: "¡Error! \nTransacción no completada",
    subtitle: "Parece que hubo un inconveniente al procesar tu transacción. Por favor, verifica los detalles ingresados e intenta nuevamente.",
    img: "/Errormark.png",
    btnAction: "Intentar de nuevo",
  },
};

export function createData(date, type, monto, status, metodo, recibo, id, usrId, reference, desc, file, servicio, fechaTransaccion, servicioEmpresa, factura_pdf, factura_xml, fecha_facturacion, concepto, empresa, extraData) {
  return { date, type, monto, status, metodo, recibo, id, usrId, reference, desc, file, servicio, fechaTransaccion, servicioEmpresa, factura_pdf, factura_xml, fecha_facturacion, concepto, empresa, extraData };
}